<div [formGroup]="form">

    <div *ngIf="isNominative" class="type-list-benef">

        <label>Type de bénéficiaire</label>

        <div *ngFor="let control of listeTypesBeneficiaire.controls; index as i" formArrayName="ListeTypesBeneficiaire">

            <div [formGroupName]="i">

                <kal-checkbox [label]="getBeneficiaryLabel(i)"
                              formControlName="Valeur">
                </kal-checkbox>

            </div>

        </div>

    </div>


    <div *ngIf="isNominative">

        <div *ngIf="listeTypesBeneficiaire.hasError('nobeneficiarytypes')" class="gup-U-color--red">Veuillez
            sélectionner au moins un type de bénéficiaire
        </div>

        <div class="gup-O-separationLine"></div>

        <div class="subtitle">Ouvrant droit</div>

    </div>

    <kal-form-field>

        <kal-radio-group [label]="isNominative ? 'Critères d\'accessibilité' : 'Accessibilité selon'"
                         formControlName="ModeAccess">
            <kal-radio value="ANC">Ancienneté</kal-radio>
            <kal-radio value="PRS">Date de présence</kal-radio>
        </kal-radio-group>

    </kal-form-field>

    <kal-form-field class="gup-C-formFieldSize--select">

        <kal-select
            [label]="(form.get('ModeAccess').value === 'ANC' ? 'Ancienneté' : 'Date de présence') + ' calculée depuis :'"
            disableFirstOptionSelection
            formControlName="IdtypeRefAnc">
            <kal-option *ngFor="let referenceDate of referenceDatesList"
                        [value]="referenceDate.Id">
                {{ referenceDate.Libelle }}
            </kal-option>
        </kal-select>

    </kal-form-field>

    <div *ngIf="shouldDisplayedSelectedDate">

        <app-shared-days-in-month-edit formControlName="DateRef"></app-shared-days-in-month-edit>

    </div>

    <div>

        <kal-form-field class="without-label">

            <kal-radio-group [label]="isNominative ? 'Cible de la règle' : ''"
                             formControlName="TypeAccessibilite"
                             kalTheme="bascule">

                <kal-radio value="accessibilityBeneficiary">
                    Accessible pour tous les ouvrants droits
                </kal-radio>

                <kal-radio value="accessibilityCriteria">
                    Accessibilité selon critères
                </kal-radio>

            </kal-radio-group>

        </kal-form-field>

        <div *ngIf="displayedAccessibilityBeneficiaryContent" class="anciennete-minmax">

            <kal-form-field>

                <kal-input formControlName="RgModAccesAnMin"
                           label="Ancienneté supérieure ou égale à"
                           type="number">
                </kal-input>

                <span>mois</span>

            </kal-form-field>

            <kal-form-field>

                <kal-input formControlName="RgModAccesAnMax"
                           label="et strictement inférieure à"
                           type="number">
                </kal-input>

                <span>mois</span>

            </kal-form-field>

            <p *ngIf="form.hasError('rgModAccesAnminsupmax')" class="gup-O-msg -error">
                L'ancienneté maximum doit être supérieure à {{form.get('RgModAccesAnMin').value}}.
            </p>

        </div>

        <div *ngIf="form.get('TypeAccessibilite').value === 'accessibilityCriteria'">

            <kal-form-field class="without-label  gup-C-formFieldSize--select">

                <kal-select disableFirstOptionSelection
                            formControlName="IdChamp"
                            label="Critère">
                    <kal-option *ngFor="let accessibilityCriteria of accessibilityCriteriaList"
                                [value]="accessibilityCriteria.Id">
                        {{ accessibilityCriteria.Libelle }}
                    </kal-option>
                </kal-select>

            </kal-form-field>

            <kal-table [columns]="columns"
                       [dataSource]="displayedAccessibilityCriteriaList"
                       [displayedColumns]="displayedAccessibilityCriteriaColumns"
                       [selection]="accessibilityCriteriaSelection"
                       class="displayed-accessibility-criteria-list">

                <tr *kalHeaderRowDef kal-header-row></tr>

                <ng-container kalColumn="AncienneteMinimum">
                    <td *kalBodyCell="let row">
                        <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                            <kal-input (click)="stopPropagation($event)"
                                       [formControl]="row.AncienneteMinimum"
                                       [errorsMessage]="{ notMinMaxSeniority: 'La valeur minimale est invalide'}"
                                       type="number">
                            </kal-input>
                        </kal-form-field>
                    </td>
                </ng-container>

                <ng-container kalColumn="AncienneteMaximum">
                    <td *kalBodyCell="let row">
                        <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                            <kal-input (click)="stopPropagation($event)"
                                       [errorsMessage]="{ notMinMaxSeniority: 'La valeur maximale est invalide'}"
                                       [formControl]="row.AncienneteMaximum"
                                       type="number">
                            </kal-input>
                        </kal-form-field>
                    </td>
                </ng-container>

            </kal-table>

        </div>

    </div>

    <div *ngIf="shouldDisplayedBeneficiary(['CON', 'ENF'])">

        <div class="gup-O-separationLine"></div>

        <div class="subtitle">Ayants droits</div>

        <div *ngIf="shouldDisplayedBeneficiary(['CON'])">

            <label>Conjoints ...</label>

            <div class="type-list-conjoint">

                <kal-checkbox formControlName="IsConjointHandicape"
                              label="handicapé">
                </kal-checkbox>

            </div>

        </div>

        <div *ngIf="shouldDisplayedBeneficiary(['ENF'])">

            <label>Enfants ...</label>

            <div class="type-list-enfant">

                <kal-checkbox formControlName="IsEnfantDirect"
                              label="directs uniquement">
                </kal-checkbox>

                <kal-checkbox formControlName="IsEnfantHandicape"
                              label="handicapés">
                </kal-checkbox>

                <kal-checkbox formControlName="IsEnfantACharge"
                              label="à charge uniquement">
                </kal-checkbox>

                <div class="tranche">

                    <kal-checkbox formControlName="AgeEnfantSelection"
                                  label="âgés de">
                    </kal-checkbox>

                    <kal-input formControlName="AgeEnfantMin"
                               type="number">
                    </kal-input>

                    <span>à</span>

                    <kal-input formControlName="AgeEnfantMax"
                               type="number">
                    </kal-input>

                    <span>ans.</span>

                </div>

            </div>

            <div *ngIf="hasAgeValue">

                <kal-form-field class="gup-C-formFieldSize--select">

                    <kal-select disableFirstOptionSelection
                                formControlName="IdTypeDateRefAge"
                                label="Âge calculé depuis">
                        <kal-option *ngFor="let referenceDate of referenceDatesList"
                                    [value]="referenceDate.Id">
                            {{ referenceDate.Libelle }}
                        </kal-option>
                    </kal-select>

                </kal-form-field>

                <div *ngIf="shouldDisplayedSelectedChildrenDate">

                    <app-shared-days-in-month-edit formControlName="DateRefEnf"></app-shared-days-in-month-edit>

                </div>

            </div>

            <kal-form-field class="gup-C-formFieldSize--select">

                <kal-select disableFirstOptionSelection
                            formControlName="IdChampAD"
                            label="Accessibilité selon"
                            placeholder="Sélectionner un critère">

                    <kal-option [value]="null">Aucun</kal-option>

                    <kal-option *ngFor="let childrenAccessibilityCriteria of childrenAccessibilityCriteriaList"
                                [value]="childrenAccessibilityCriteria.Id">
                        {{ childrenAccessibilityCriteria.Libelle }}
                    </kal-option>

                </kal-select>

            </kal-form-field>

            <kal-table *ngIf="form.get('IdChampAD').value"
                       [columns]="columns"
                       [dataSource]="displayedChildrenAccessibilityCriteriaList"
                       [displayedColumns]="displayedChildrenAccessibilityCriteriaColumns"
                       [selection]="childrenAccessibilityCriteriaSelection"
                       class="displayed-children-accessibility-criteria-columns">

                <tr *kalHeaderRowDef kal-header-row></tr>

            </kal-table>

        </div>

    </div>

</div>
